import React from "react";
import { HomepageBody } from "../styles/components/GroupPage";
import CommonAppBar from "../utils/Appbar";

const AccountPage = () => {

    return (
        <HomepageBody>
            <CommonAppBar section='account' />
        </HomepageBody>
    );
};

export default AccountPage;
